module.exports = __webpack_public_path__ + "img/vip-icon-7.41ddcd41.png";